import { ExclamationTriangleIcon } from '@heroicons/react/20/solid';
import { UseFormReturn, useWatch } from 'react-hook-form';

import { serviceTypeOptions } from 'src/features/add-trip/ServiceDetails/serviceTypeOptions';

import { SchemeMetaFormValues } from './metaDefaultValues';

export function ScopeCheckAlert({
  methods,
}: {
  methods: UseFormReturn<SchemeMetaFormValues>;
}) {
  const rawSelected = useWatch({
    control: methods.control,
    name: 'service_types',
  });

  const knownValues = new Set(serviceTypeOptions.map((o) => o.value));
  const selectedCount = new Set(
    (rawSelected ?? []).filter((t) => knownValues.has(t))
  ).size;
  const totalCount = serviceTypeOptions.length;

  if (selectedCount === 0) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      aria-atomic="true"
      className="flex gap-3 rounded-md border border-yellow-400 bg-yellow-50 p-4"
    >
      <ExclamationTriangleIcon
        aria-hidden="true"
        className="h-5 w-5 flex-shrink-0 text-yellow-400"
      />
      <p className="text-sm text-yellow-800">
        <strong>Scope check:</strong> This pricing model applies to{' '}
        <strong>
          {selectedCount} of {totalCount}
        </strong>{' '}
        service types. Trips outside this scope won't receive a price from this
        model.
      </p>
    </div>
  );
}
